const getBackgroundAdObj = (imagePoster, position) => {
    if(imagePoster) {
        imagePoster.position = position ? position : 0

        return imagePoster
    } else {
        return false
    }
}

export default getBackgroundAdObj